// removed by extract-text-webpack-plugin
module.exports = {"pagi-skipbtn":"Pagination__pagi-skipbtn","pagiSkipbtn":"Pagination__pagi-skipbtn","pagination-holder":"Pagination__pagination-holder","paginationHolder":"Pagination__pagination-holder","pagination":"Pagination__pagination","active":"Pagination__active","disabled":"Pagination__disabled","input":"Pagination__input","icon-left":"Pagination__icon-left","iconLeft":"Pagination__icon-left","hidden-spoken":"Pagination__hidden-spoken","hiddenSpoken":"Pagination__hidden-spoken","leftblur":"Pagination__leftblur","rightblur":"Pagination__rightblur"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Pagination/Pagination.css
// module id = 1208
// module chunks = 8